/*
================================================================================
  1 ALANA 1 BEDAVA - SEPET HEDIYE POPUP'I   v4
  limoya.com | Minimog - OS 2.0 v5.6.0 (FoxEcom) + FoxKit AIO Upsell
  ahmetmusaok.com.tr
================================================================================
*/
(function () {
  'use strict';

  /* =========================================================================
     AYARLAR
     ========================================================================= */
  var CFG = {
    // 1. adimda olusturdugun section dosyasinin adi (uzantisiz)
    sectionId: '1a1b-status',

    // Popup'in acilacagi adetler
    triggerCounts: [1, 3, 5, 7],

    // 'total'   = sepetteki TUM 1A1B urunlerinin adetleri TOPLANIR.  <-- AKTIF
    //             Koleksiyon disi urunler bu toplama girmez.
    //             Ornek: 1 Rossi + 2 Caty = 3 -> tetikler.
    // 'product' = her 1A1B urunu kendi adediyle degerlendirilir.
    countMode: 'total',

    // Sepet degisiminden sonra bekleme (ms). Drawer animasyonu icin.
    delay: 550,

    zIndex: 2147482000,

    // Baska bir modal aciksa ertele. Bos: tahmin secici yazmadim.
    // Ust uste binme yasarsan o elemanin secicisini ekle.
    waitForSelectors: [],
    maxDefer: 6,

    onePerCount: true,

    // Sayfa acilisinda da sepeti kontrol et.
    // GEREKLI: sepet SAYFASINDAN (/cart) urun silmek sayfayi yeniden yukler;
    // bu durumda 'cart:updated' olayi hic olusmaz. Tek yakalama noktasi budur.
    // Maliyet kontrollu: son bilinen adet 0 ise istek ATILMAZ (asagi bak).
    checkOnLoad: true,

    // Konsola teshis yazdirir. Kurulum testinden sonra false yap.
    debug: true,

    css: {
      bg:        '#ffffff',
      bgAlt:     '#f5f5f5',
      text:      '#222222',
      subtext:   '#666666',
      border:    '#dedede',
      btn:       '#222222',
      btnLabel:  '#ffffff',
      accent:    '#DA3F3F',
      radius:    '6px',
      radiusTop: '20px'
    },

    // {n} = adet, {title} = urun adi
    text: {
      eyebrow:  'HEDİYE HAKKIN VAR',
      title:    'Hediye ürünün seni bekliyor',
      bodyOne:  'Sepetine eklediğin <b>{title}</b> kampanyaya dahil. <b>1 ürün daha hediye</b> — hediyeni seç, ücreti sepetten düşülsün.',
      bodyMany: 'Sepetinde <b>{n} adet</b> kampanya ürünü var. <b>1 ürün daha</b> ekleyerek hediyeni al.',
      primary:  'Hediyemi Seç',
      secondary:'Sepeti Tamamla',
      close:    'Kapat'
    },

    primaryUrl:   '/collections/1-alana-1-bedava',
    secondaryUrl: '/cart'
  };

  /* =========================================================================
     BURADAN SONRASINI DEGISTIRMENE GEREK YOK
     ========================================================================= */

  var NS = 'lmy1a1b';
  var K_SHOWN = NS + ':shown';
  var K_LAST  = NS + ':last';   // son bilinen 1A1B adedi (bos sepette bosuna istek atmamak icin)

  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var MUTATION = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/i;

  var timer = null, deferCount = 0, busy = false, busyAt = 0, lastCart = null;
  var built = false, root = null, box = null, lastFocused = null;

  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function ssDel(k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  function log() {
    if (!CFG.debug || !window.console) return;
    try { console.log.apply(console, ['[1A1B]'].concat([].slice.call(arguments))); } catch (e) {}
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (ch) {
      return ch === '&' ? '&amp;' : ch === '<' ? '&lt;' : ch === '>' ? '&gt;' : '&quot;';
    });
  }

  /* ================== tetikleme ================== */

  function schedule(cart) {
    if (cart && cart.items) lastCart = cart;
    // Guvenlik: bir istek hic sonuclanmazsa busy takili kalmasin.
    if (busy && Date.now() - busyAt > 15000) { busy = false; log('busy kilidi zaman asimiyla acildi'); }
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { timer = null; run(); }, CFG.delay);
  }

  function hookThemeEvents() {
    document.addEventListener('cart:updated', function (e) {
      schedule(e && e.detail ? e.detail.cart : null);
    }, { passive: true });

    document.addEventListener('product-ajax:added', function () {
      schedule(null);
    }, { passive: true });

    // Sepetten urun cikarma / adet dusurme yollari.
    // 'cart:refresh' documentElement uzerinde bubbles:true ile gonderilir,
    // bu yuzden document seviyesinde yakalanir.
    document.addEventListener('cart:refresh', function () { schedule(null); }, { passive: true });
    document.addEventListener('cart:change',  function () { schedule(null); }, { passive: true });
  }

  // Sayfa acilisi + geri tusu (bfcache). Sepet sayfasindan silme sonrasi
  // yeniden yuklenen sayfayi burasi yakalar.
  function hookPageLoad() {
    var fired = false;
    function once() {
      if (fired) return;
      fired = true;
      // Son bilinen adet 0 ise sepette kampanya urunu yok demektir; istek atma.
      if (ssGet(K_LAST) === '0') { log('sayfa acilisi: son bilinen adet 0, istek atlandi'); return; }
      schedule(null);
    }
    document.addEventListener('page:loaded', once, { passive: true });
    window.addEventListener('pageshow', function (e) {
      if (e && e.persisted) { fired = false; once(); }   // bfcache ile geri donus
    }, { passive: true });
    // 'page:loaded' herhangi bir sebeple gelmezse yedek
    setTimeout(once, 3000);
  }

  function hookFetch() {
    if (!window.fetch) return;
    var original = window.fetch;
    window.fetch = function (input, init) {
      var p = original.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input
                : (input && typeof input.url === 'string' ? input.url : '');
        if (url && MUTATION.test(url)) {
          // Promise tuketilmez, klonlanmaz, degistirilmez.
          p.then(function (r) { if (r && r.ok) schedule(null); }, function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  function hookXhr() {
    var proto = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
    if (!proto || !proto.open || !proto.send) return;
    var open = proto.open, send = proto.send;
    proto.open = function (m, u) {
      try { this.__lmyU = typeof u === 'string' ? u : ''; } catch (e) {}
      return open.apply(this, arguments);
    };
    proto.send = function () {
      try {
        var self = this;
        if (self.__lmyU && MUTATION.test(self.__lmyU)) {
          self.addEventListener('load', function () {
            if (self.status >= 200 && self.status < 300) schedule(null);
          });
        }
      } catch (e) {}
      return send.apply(this, arguments);
    };
  }

  function otherOverlayOpen() {
    var sel = CFG.waitForSelectors;
    if (!sel || !sel.length) return false;
    for (var i = 0; i < sel.length; i++) {
      try { if (document.querySelector(sel[i])) return true; } catch (e) {}
    }
    return false;
  }

  /* ================== sunucudan kampanya durumu ================== */

  function rootPath() {
    try {
      var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      if (r) return r;
    } catch (e) {}
    return '/';
  }

  // Liquid'in verdigi kesin cevap. Istemcide uyelik tahmini YOK.
  function fetchStatus() {
    if (!nativeFetch) return Promise.resolve(null);
    var url = rootPath() + '?section_id=' + encodeURIComponent(CFG.sectionId) +
              '&_=' + Date.now();

    return nativeFetch(url, {
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) { log('section yaniti bos veya hatali'); return null; }

        var host = document.createElement('div');
        host.innerHTML = html;
        var el = host.querySelector('#' + NS + '-status');
        if (!el) {
          log('section bulundu ama #' + NS + '-status yok. sections/' +
              CFG.sectionId + '.liquid dogru kurulmus mu?');
          return null;
        }

        var qtys = (el.getAttribute('data-qtys') || '')
          .split(',')
          .filter(function (v) { return v !== ''; })
          .map(function (v) { return parseInt(v, 10) || 0; });

        var cnt = parseInt(el.getAttribute('data-count'), 10) || 0;
        ssSet(K_LAST, String(cnt));

        return {
          count: cnt,
          lines: parseInt(el.getAttribute('data-lines'), 10) || 0,
          qtys:  qtys,
          title: el.getAttribute('data-title') || '',
          image: el.getAttribute('data-image') || ''
        };
      })
      .catch(function (e) { log('section istegi basarisiz', e); return null; });
  }

  /* ================== ana akis ================== */

  function run() {
    if (busy) return;

    if (otherOverlayOpen() && deferCount < CFG.maxDefer) {
      deferCount++;
      timer = setTimeout(function () { timer = null; run(); }, 700);
      return;
    }
    deferCount = 0;

    // Sepet bosaldiysa istek atma.
    if (lastCart && lastCart.items && lastCart.items.length === 0) {
      lastCart = null;
      ssDel(K_SHOWN);
      ssSet(K_LAST, '0');
      log('sepet bos, istek atlandi');
      return;
    }
    lastCart = null;
    busy = true;
    busyAt = Date.now();

    fetchStatus()
      .then(function (st) {
        // Kesin bilgi yoksa POPUP GOSTERME.
        if (!st) return;

        log('kampanya urunu adedi:', st.count, '| kalem:', st.lines, '| adetler:', st.qtys);

        if (st.count === 0) { ssDel(K_SHOWN); return; }

        var count, stateKey;
        if (CFG.countMode === 'product') {
          count = null;
          for (var i = st.qtys.length - 1; i >= 0; i--) {
            if (CFG.triggerCounts.indexOf(st.qtys[i]) !== -1) { count = st.qtys[i]; break; }
          }
          if (count === null) { ssDel(K_SHOWN); return; }
          stateKey = 'p:' + st.qtys.join('-');
        } else {
          count = st.count;
          if (CFG.triggerCounts.indexOf(count) === -1) { ssDel(K_SHOWN); return; }
          stateKey = 't:' + count;
        }

        if (CFG.onePerCount && ssGet(K_SHOWN) === stateKey) { log('bu durum icin zaten gosterildi'); return; }

        ssSet(K_SHOWN, stateKey);
        show(count, st);
      })
      .catch(function () {})
      .then(function () { busy = false; }, function () { busy = false; });
  }

  /* ================== arayuz ================== */

  function injectStyles() {
    var c = CFG.css;
    var css =
    '.' + NS + '-ov{position:fixed;inset:0;z-index:' + CFG.zIndex + ';display:flex;' +
      'align-items:flex-end;justify-content:center;background:rgba(34,34,34,.45);' +
      'opacity:0;visibility:hidden;transition:opacity .25s ease,visibility .25s ease;' +
      'font-family:inherit;-webkit-tap-highlight-color:transparent}' +
    '.' + NS + '-ov.is-open{opacity:1;visibility:visible}' +

    '.' + NS + '-box{position:relative;width:100%;max-width:440px;background:' + c.bg + ';' +
      'color:' + c.text + ';border-radius:' + c.radiusTop + ' ' + c.radiusTop + ' 0 0;' +
      'padding:26px 22px calc(22px + env(safe-area-inset-bottom));box-sizing:border-box;' +
      'box-shadow:0 -20px 60px -12px rgba(0,0,0,.28);transform:translate3d(0,32px,0);' +
      'transition:transform .34s cubic-bezier(.16,1,.3,1);' +
      'max-height:88vh;overflow-y:auto;-webkit-overflow-scrolling:touch}' +
    '.' + NS + '-ov.is-open .' + NS + '-box{transform:translate3d(0,0,0)}' +
    '.' + NS + '-box.is-drag{transition:none}' +

    '.' + NS + '-grab{width:38px;height:4px;border-radius:99px;background:' + c.border + ';' +
      'margin:-12px auto 16px;cursor:grab;touch-action:none}' +

    '.' + NS + '-x{position:absolute;top:12px;right:12px;width:32px;height:32px;border:0;' +
      'padding:0;background:transparent;color:' + c.subtext + ';cursor:pointer;' +
      'border-radius:50%;display:flex;align-items:center;justify-content:center;' +
      'transition:background .15s ease,color .15s ease}' +
    '.' + NS + '-x:hover{background:' + c.bgAlt + ';color:' + c.text + '}' +
    '.' + NS + '-x svg{width:15px;height:15px;display:block}' +

    '.' + NS + '-eyebrow{position:relative;display:inline-flex;align-items:center;' +
      'overflow:hidden;font-size:10px;font-weight:600;letter-spacing:.13em;' +
      'color:' + c.accent + ';background:rgba(218,63,63,.08);border-radius:99px;' +
      'padding:6px 12px;margin-bottom:18px;line-height:1}' +
    '.' + NS + '-eyebrow::after{content:"";position:absolute;top:0;left:0;width:38%;height:100%;' +
      'background:linear-gradient(100deg,transparent,rgba(255,255,255,.75),transparent);' +
      'transform:translate3d(-160%,0,0);animation:' + NS + '-sheen 3.4s ease-in-out 1s infinite}' +
    '@keyframes ' + NS + '-sheen{0%{transform:translate3d(-160%,0,0)}' +
      '45%,100%{transform:translate3d(420%,0,0)}}' +

    '.' + NS + '-row{display:flex;align-items:center;gap:14px;margin-bottom:20px}' +
    '.' + NS + '-thumb{width:66px;height:66px;flex:0 0 66px;border-radius:' + c.radius + ';' +
      'object-fit:cover;background:' + c.bgAlt + ';border:1px solid ' + c.border + ';display:block}' +
    '.' + NS + '-plus{flex:0 0 auto;color:' + c.subtext + ';font-size:15px;line-height:1}' +
    '.' + NS + '-gift{width:66px;height:66px;flex:0 0 66px;border-radius:' + c.radius + ';' +
      'background:rgba(218,63,63,.05);border:1px dashed rgba(218,63,63,.4);color:' + c.accent + ';' +
      'display:flex;align-items:center;justify-content:center}' +
    '.' + NS + '-gift svg{width:28px;height:28px;display:block}' +

    '.' + NS + '-h{margin:0 0 8px;font-size:21px;line-height:1.28;font-weight:500;' +
      'letter-spacing:-.01em;color:' + c.text + '}' +
    '.' + NS + '-p{margin:0 0 22px;font-size:14px;line-height:1.62;color:' + c.subtext + '}' +
    '.' + NS + '-p b{color:' + c.text + ';font-weight:600}' +

    '.' + NS + '-btns{display:flex;flex-direction:column;gap:10px}' +
    '.' + NS + '-b{display:flex;align-items:center;justify-content:center;width:100%;' +
      'min-height:50px;padding:14px 18px;border-radius:' + c.radius + ';font-size:14px;' +
      'font-weight:500;letter-spacing:.02em;text-decoration:none;cursor:pointer;' +
      'border:1px solid transparent;box-sizing:border-box;font-family:inherit;' +
      'transition:opacity .16s ease,background .16s ease}' +
    '.' + NS + '-b1{background:' + c.btn + ';color:' + c.btnLabel + '}' +
    '.' + NS + '-b1:hover{opacity:.86}' +
    '.' + NS + '-b2{background:' + c.bg + ';color:' + c.text + ';border-color:' + c.border + '}' +
    '.' + NS + '-b2:hover{background:' + c.bgAlt + '}' +

    '@media (min-width:750px){' +
      '.' + NS + '-ov{align-items:center;-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px)}' +
      '.' + NS + '-box{border-radius:' + c.radius + ';max-width:452px;padding:34px 32px 30px;' +
        'transform:translate3d(0,10px,0) scale(.97);box-shadow:0 30px 70px -14px rgba(0,0,0,.3)}' +
      '.' + NS + '-ov.is-open .' + NS + '-box{transform:translate3d(0,0,0) scale(1)}' +
      '.' + NS + '-grab{display:none}' +
      '.' + NS + '-btns{flex-direction:row-reverse}' +
    '}' +
    '@media (prefers-reduced-motion:reduce){' +
      '.' + NS + '-ov,.' + NS + '-box{transition:none!important}' +
      '.' + NS + '-box{transform:none!important}' +
      '.' + NS + '-eyebrow::after{animation:none;display:none}' +
    '}';

    var el = document.createElement('style');
    el.setAttribute('data-' + NS, '');
    el.appendChild(document.createTextNode(css));
    document.head.appendChild(el);
  }

  var SVG_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
    'stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';

  var SVG_GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/>' +
    '<line x1="12" y1="22" x2="12" y2="7"/>' +
    '<path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>' +
    '<path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';

  function build() {
    injectStyles();

    root = document.createElement('div');
    root.className = NS + '-ov';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-labelledby', NS + '-h');

    root.innerHTML =
      '<div class="' + NS + '-box" role="document">' +
        '<div class="' + NS + '-grab" data-' + NS + '-grab aria-hidden="true"></div>' +
        '<button type="button" class="' + NS + '-x" data-' + NS + '-close aria-label="' +
          CFG.text.close + '">' + SVG_CLOSE + '</button>' +
        '<span class="' + NS + '-eyebrow">' + CFG.text.eyebrow + '</span>' +
        '<div class="' + NS + '-row">' +
          '<img class="' + NS + '-thumb" alt="" loading="lazy" decoding="async" data-' + NS + '-img>' +
          '<span class="' + NS + '-plus" aria-hidden="true">+</span>' +
          '<span class="' + NS + '-gift">' + SVG_GIFT + '</span>' +
        '</div>' +
        '<h2 class="' + NS + '-h" id="' + NS + '-h">' + CFG.text.title + '</h2>' +
        '<p class="' + NS + '-p" data-' + NS + '-body></p>' +
        '<div class="' + NS + '-btns">' +
          '<a class="' + NS + '-b ' + NS + '-b1" href="' + CFG.primaryUrl + '">' + CFG.text.primary + '</a>' +
          '<a class="' + NS + '-b ' + NS + '-b2" href="' + CFG.secondaryUrl + '">' + CFG.text.secondary + '</a>' +
        '</div>' +
      '</div>';

    box = root.querySelector('.' + NS + '-box');

    root.addEventListener('click', function (e) {
      if (e.target === root || (e.target.closest && e.target.closest('[data-' + NS + '-close]'))) {
        e.preventDefault();
        hide();
      }
    });

    initDrag(root.querySelector('[data-' + NS + '-grab]'));
    document.body.appendChild(root);
    built = true;
  }

  function initDrag(handle) {
    if (!handle) return;
    var startY = 0, dy = 0, dragging = false;

    handle.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches.length) return;
      startY = e.touches[0].clientY; dy = 0; dragging = true;
      box.classList.add('is-drag');
    }, { passive: true });

    handle.addEventListener('touchmove', function (e) {
      if (!dragging || !e.touches || !e.touches.length) return;
      dy = Math.max(0, e.touches[0].clientY - startY);
      box.style.transform = 'translate3d(0,' + dy + 'px,0)';
    }, { passive: true });

    handle.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      box.classList.remove('is-drag');
      box.style.transform = '';
      if (dy > 80) hide();
    }, { passive: true });
  }

  function onKey(e) { if (e.key === 'Escape' || e.keyCode === 27) hide(); }

  function show(count, st) {
    if (!built) build();

    var img = root.querySelector('[data-' + NS + '-img]');
    if (st && st.image) { img.src = st.image; img.style.display = ''; }
    else { img.removeAttribute('src'); img.style.display = 'none'; }

    var tpl = (count === 1) ? CFG.text.bodyOne : CFG.text.bodyMany;
    root.querySelector('[data-' + NS + '-body]').innerHTML = tpl
      .split('{n}').join(String(count))
      .split('{title}').join(esc(st && st.title ? st.title : ''));

    lastFocused = document.activeElement;
    void root.offsetWidth;
    root.classList.add('is-open');
    document.addEventListener('keydown', onKey);

    var first = root.querySelector('.' + NS + '-b1');
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
  }

  function hide() {
    if (!root) return;
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    if (lastFocused && lastFocused.focus) {
      try { lastFocused.focus({ preventScroll: true }); } catch (e) {}
    }
    lastFocused = null;
  }

  /* ================== baslat ================== */

  try {
    hookThemeEvents();
    hookFetch();
    hookXhr();

    if (CFG.checkOnLoad) hookPageLoad();

    // Elle test icin:  window.Limoya1A1B.test()
    window.Limoya1A1B = {
      test: function () { ssDel(K_SHOWN); ssDel(K_LAST); schedule(null); },
      status: fetchStatus,
      reset: function () { ssDel(K_SHOWN); ssDel(K_LAST); }
    };
  } catch (e) {}
})();